import name from './name'

const selectSliceData = state => state[name]
const selectOnboardingProfile = state => selectSliceData(state).onboarding
const selectOnboarding = state => selectSliceData(state).onboarding?.onboarding
const selectSkillbiteCSVPopoverOpen = state => selectSliceData(state).skillbiteCSVPopperOpen
const selectProfilePopoverOpen = state => selectSliceData(state).playlistPopperOpen
const selectMyLearningBadge = state => selectSliceData(state).myLearningBadge
const selectMyLearningFeedback = state => selectSliceData(state).myLearningFeedback
const selectHomeEnterprisePopoverOpen = state => selectSliceData(state).homeEnterprisePopperOpen
const selectChecklist = state => selectSliceData(state).checklist
const selectChecklistItems = state => selectSliceData(state).checklistItems

export { selectOnboardingProfile, selectOnboarding, selectSkillbiteCSVPopoverOpen, selectProfilePopoverOpen, selectMyLearningBadge, selectMyLearningFeedback, selectHomeEnterprisePopoverOpen, selectChecklist, selectChecklistItems }
